import React from 'react';
import { Avatar, Tag } from '@opendate-app/setlist';

function MusicTasteCard({ rankedArtists = [], rankedGenres = [] }) {
  if (rankedArtists.length === 0 && rankedGenres.length === 0) return null;

  return (
    <div className="cdp-card">
      <h2 className="cdp-card-title">Music taste</h2>

      {rankedArtists.length > 0 && (
        <div className="cdp-artist-chip-row">
          {rankedArtists.map((artist) => (
            <a key={artist.id} href={artist.href} className="cdp-artist-chip">
              <Avatar size="2xl" src={artist.avatar_url} initials={(artist.name || '?')[0]} alt={artist.name} />
              <div className="cdp-artist-chip-name">{artist.name}</div>
            </a>
          ))}
        </div>
      )}

      {rankedArtists.length > 0 && rankedGenres.length > 0 && (
        <div className="cdp-card-divider" />
      )}

      {rankedGenres.length > 0 && (
        <div className="cdp-pill-row">
          {rankedGenres.map((genre) => (
            <Tag key={genre}>{genre}</Tag>
          ))}
        </div>
      )}
    </div>
  );
}

export default MusicTasteCard;
